import React, { useEffect, useRef, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Col, Row, Card, UncontrolledPopover, PopoverBody } from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import action from "../../../assets/icons/action.svg"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { Link, useLocation, useNavigate } from "react-router-dom"
import {
  fetchHrmsGradeControl,
  updateGradeControlStatus,
} from "../../../services/Hrms/hrms"
import capitalizeFirstLetter from "../../../utils/capitalizeFirstLetter"
import LedgerFilter from "./filter"
import {
  deleteledger,
  fetchFinanceLedgerSearch,
} from "../../../services/finance/finance"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import NumberFormat from "../../../utils/numberFormat"
import LogoutPopup from "../../../components/VerticalLayout/logoutpopup"

const LedgerFinance = () => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Ledger${companyname ? ` | ${companyname}` : "MEP -Hub"}`

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)
  const desimalrange = localStorage.getItem("desimalrange")

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""
  const group_id = locations?.state?.group || ""
  const search_text = locations?.state?.search || ""

  const navigate = useNavigate()
  const [refresh, setRefresh] = useState(0)
  const [classData, setClassData] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [country, setCountry] = useState("")
  const [group, setGroup] = useState("")
  const [page, setPage] = useState("")
  const [dataPerPage, setDataPerPage] = useState(25)
  const [logoutModal, setLogoutModal] = useState(false)
  const [deleteId, setDeleteId] = useState("")
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)
  const [groupsData, setGroupsData] = useState(null)
  const [searchedText, setSearchedText] = useState("")

  useEffect(() => {
    if (group_id || search_text) {
      setGroup(group_id ? group_id?.value : "")
      setSearch(search_text ? search_text : "")
      setGroupsData(group_id ? group_id : null)
      setSearchedText(search_text ? search_text : "")
      setPage(1)
      setDataPerPage(25)
    }
  }, [])

  const handleActivate = item => {
    const updateStatus = async item => {
      const response = await updateGradeControlStatus(item)
      toastSuccess(response?.message)
      setRefresh(refresh + 1)
    }
    updateStatus(item)
  }

  const handleDelete = item => {
    const deleteLedger = async item => {
      try {
        const response = await deleteledger(item)
        toastSuccess(response?.message)
        setRefresh(refresh + 1)
      } catch (err) {
        toastError(err?.message)
      }
    }
    deleteLedger(item)
  }

  console.log(`loggedUser`, loggedUser)

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const handilRest = () => {
    setRefresh(refresh + 1)
    setPage(1)
    setDataPerPage(25)
  }

  const columns = [
    {
      label: "Ledger Name",
      renderCell: item => {
        return (
          <div
            onClick={() =>
              navigate(`/finance-ledger-acc`, {
                state: {
                  item,
                  bread: crumb,
                }
              })
            }
            className="pointer fw-bold"
          >
            {item?.name ? capitalizeFirstLetter(item?.name) : "-"}
          </div>
        )
      },
    },
    {
      label: <div className="text-end pe-5">Opening Balance</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(
            Number(item?.opening_balance),
            desimalrange,
            desimalrange
          )}{" "}
          {item?.balance_type == "debit" ? "Dr" : "Cr"}
        </div>
      ),
    },
    // {
    //   label: "Status",
    //   renderCell: item => (
    //     <div>
    //       <span
    //         className={`font-13 ${
    //           item?.status == 1 ? "status-active" : "status-inactive"
    //         }`}
    //       >
    //         {item?.status == 1 ? "Active" : "Inactive"}
    //       </span>
    //     </div>
    //   ),
    // },
    {
      label: "Action",
      renderCell: item => (
        <>
          <div>
            <span id={`PopoverLegacy-${item?.id}`}>
              <img src={action} alt="" className="pointer" />
            </span>
          </div>
          <UncontrolledPopover
            placement="bottom"
            target={`PopoverLegacy-${item?.id}`}
            trigger="legacy"
          >
            <PopoverBody>
              {loggedUser?.permission?.some(
                permissionItem => permissionItem?.name === "ledger_edit"
              ) && (
                  <div
                    className="table-popup-content"
                    onClick={() => navigate(`/finance-ledger/edit/${item?.id}`, { state: { group: groupsData, search: search } })}
                  >
                    Edit
                  </div>
                )}
              {loggedUser?.data?.roles?.some(itm => itm?.id == 1) && (
                <div
                  className={`table-popup-content`}
                  // onClick={() => handleDelete(item?.id)}
                  onClick={e => {
                    e.preventDefault()
                    setLogoutModal(true)
                    setDeleteId(item?.id)
                  }}
                >
                  Delete
                </div>
              )}
              {/* <div
                className={`${
                  item?.status == 1 ? "popover-border" : ""
                } table-popup-content`}
                onClick={() => handleActivate(item?.id)}
              >
                {item?.status === 1 ? "Deactivate" : "Activate"}
              </div> */}
            </PopoverBody>
          </UncontrolledPopover>
        </>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  useEffect(() => {
    const fetchClass = async () => {
      const response = await fetchFinanceLedgerSearch({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${search ? `&searchText=${search}` : "&searchText"
          }${`&sortOrder=asc`}${country ? `&country_id=${country}` : ""}${page ? `&page=${page}` : ""
          }${group ? `&account_group_id=${group}` : ""}${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""
          }${`&hide_stock_in_hand=true`}${`&sortOrder=asc`}`,
      })
      // setClassData(response)
      const newData = response?.data?.data || [];

      setClassData(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
    }
    fetchClass()
  }, [refresh, status, search, country, page, group, dataPerPage])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;

      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }

      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < classData?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };

    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [classData, page]);

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
    setDataPerPage(25)
  }
  const handleCountryChange = id => {
    setCountry(id)
    setPage(1)
    setDataPerPage(25)
  }
  const handleGroupChange = id => {
    setGroup(id?.value)
    setGroupsData(id)
    setPage(1)
    setDataPerPage(25)
  }
  const handleSearchChange = data => {
    console.log("search", data)
    setSearch(data)
    setPage(1)
    setDataPerPage(25)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Procurement"
              breadcrumbObject={[
                { title: "Finance", link: "/finance" },
                { title: crumb || "Master", link: "/finance" },
                { title: "Ledgers", link: "/finance-ledger" },
              ]}
            />
            {loggedUser?.permission?.some(
              permissionItem => permissionItem?.name === "ledger_create"
            ) && (
                <Link
                  to="/finance-ledger/add"
                  state={{ menuLabel: crumb }}
                  className={"px-2 mb-3 me-2 btn btn-primary"}
                >
                  {"+ Ledger"}
                </Link>
              )}
          </div>
          <Card className="me-2 px-2 pb-2">
            <LedgerFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              handleCountryChange={handleCountryChange}
              handilGroupdata={groupsData}
              searchedText={searchedText}
              handleGroupChange={handleGroupChange}
              sampleUrl={"download/ledger.xlsx"}
              importUrl={"ledger/import"}
              isImport={true}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                <div ref={tableContainerRef} style={{ maxHeight: "490px", overflowY: "auto" }}>
                  {classData && (
                    <UpdateTable
                      className="mt-5"
                      nodes={classData?.data?.data}
                      paginate={classData?.data}
                      columns={columns}
                      CurrentPage={page}
                      handlePagination={handlePaginate}
                      handleSizePerPage={handleSizePerPageChange}
                      tableWidth="40% 40% 20%"
                      mobileWidth="40% 40% 20%"
                      isLoading={isLoadingNextPage}
                      hidePaginate={true}
                    />
                  )}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
      <LogoutPopup
        isOpen={logoutModal}
        toggle={() => setLogoutModal(!logoutModal)}
        ledgerpop={true}
        deleteId={deleteId}
        handilRest={handilRest}
      />
    </React.Fragment>
  )
}

export default LedgerFinance
